import { render, staticRenderFns } from "./systemDialog.vue?vue&type=template&id=50a1daa4&scoped=true&"
import script from "./systemDialog.vue?vue&type=script&lang=js&"
export * from "./systemDialog.vue?vue&type=script&lang=js&"
import style0 from "./systemDialog.vue?vue&type=style&index=0&id=50a1daa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1daa4",
  null
  
)

export default component.exports